<div>
  <div class="row">
    <div class="col-12 col-sm-9 col-md-6 col-lg-3">
      <app-toogle [control]="fdFormGroup.controls['getTemplates']"></app-toogle>
    </div>
  </div>
  @if (createNewFormCaseVisible) {
    <div class="row">
      <div class="col-12 col-sm-9 col-md-6 col-lg-3">
        <app-select [itemsSource]="fdTemplates" [control]="fdFormGroup.controls['formTemplate']"></app-select>
      </div>
      @if (fdFormIsSeleceted) {
        <div class="create-button col-12 col-sm-9 col-md-6 col-lg-3">
          <i>+</i
            ><button class="link-btn" type="button" [disabled]="!fdFormIsSeleceted" (click)="createFormCase()">
            {{ 'FASTIGHETSAGARNA_DOKUMENT.CREATE_CASE' | translate }}
          </button>
        </div>
      }
    </div>
  }
  @if (fdFormIsSeleceted) {
    <div class="row">
      <p class="col-12 help-text">{{ formDescription }}</p>
    </div>
  }

  <app-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [preferencesKey]="'rent.form-cases-fastighetsagarna.list'"
    (rowClick)="onRowClicked($event)"
  ></app-list-view>
</div>
